import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewformaKonekt = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 217.14667 217.14667",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1.3333333,0,0,-1.3333333,0,217.14667) scale(0.1)",
		children: /* @__PURE__ */ _jsx("path", { d: "M 593.551,189.371 1101.1,1414.71 V 696.922 Z M 1101.1,595.879 V 71.4805 L 577.984,72.7617 Z M 187.984,1239.95 506.605,1558.59 H 957.219 Z M 71.4531,579.461 V 1114.34 L 984.566,1492.57 Z M 1035.09,1442.05 479.254,100.191 86.25,493.219 Z M 1172.55,768.375 V 1414.7 l 189.3,-457.024 z m 273.59,172.547 111.04,111.038 V 672.828 Z M 1172.55,123.359 v 543.977 l 218.89,218.887 159.32,-384.633 z m 244,889.021 -177.98,429.67 303.82,-303.84 z m 198.15,153.18 -449.14,449.14 c -8.99,8.99 -20.94,13.94 -33.65,13.94 H 496.73 c -12.71,0 -24.664,-4.95 -33.652,-13.94 L 13.9414,1165.56 C 4.95313,1156.57 0,1144.63 0,1131.91 V 496.73 C 0,484.02 4.95313,472.07 13.9414,463.078 L 463.074,13.9414 C 472.066,4.94922 484.02,0 496.73,0 h 635.18 c 12.71,0 24.66,4.96094 33.65,13.9414 L 1614.7,463.078 c 8.99,8.992 13.94,20.942 13.94,33.652 v 635.18 c 0,12.71 -4.95,24.66 -13.94,33.65" })
	})]
});
export default SvgNewformaKonekt;
